import { DefaultState } from '@src/redux/types'

import {
  EXTERNAL_LETTERS_LIST,
  EXTERNAL_LETTER_COMMENT_TEMPLATES,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE,
  EXTERNAL_LETTER_COMPLETE,
  EXTERNAL_LETTER_COMPLETE_EXECUTION,
  EXTERNAL_LETTER_CONFIRM_INFORMED,
  EXTERNAL_LETTER_DELETE,
  EXTERNAL_LETTER_ITEM,
  EXTERNAL_LETTER_PROVIDE_RESOLUTION,
  EXTERNAL_LETTER_REQUIRE_UPDATE,
  EXTERNAL_LETTER_SEND_TO_INFORM,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  // Legacy LETTER_INCOMING_LIST and LETTER_OUTGOING_LIST state is disabled.
  [EXTERNAL_LETTERS_LIST]: DefaultState<`${typeof API.EXTERNAL_LETTERS_LIST}`, 'get'>
  [EXTERNAL_LETTER_ITEM]: DefaultState<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'get'>
  [EXTERNAL_LETTER_DELETE]: DefaultState<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'delete'>
  [EXTERNAL_LETTER_COMMENT_TEMPLATES]: DefaultState<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`, 'get'>
  [EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE]: DefaultState<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`, 'post'>
  [EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE]: DefaultState<
    `${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}{id}`,
    'delete'
  >
  [EXTERNAL_LETTER_SEND_TO_INFORM]: DefaultState<`${typeof API.EXTERNAL_LETTERS_SEND_TO_INFORM}`, 'post'>
  [EXTERNAL_LETTER_PROVIDE_RESOLUTION]: DefaultState<`${typeof API.EXTERNAL_LETTERS_RESOLUTION}`, 'post'>
  [EXTERNAL_LETTER_CONFIRM_INFORMED]: DefaultState<`${typeof API.EXTERNAL_LETTERS_CONFIRM_INFORMED}`, 'post'>
  [EXTERNAL_LETTER_COMPLETE_EXECUTION]: DefaultState<`${typeof API.EXTERNAL_LETTERS_COMPLETE_EXECUTION}`, 'post'>
  [EXTERNAL_LETTER_REQUIRE_UPDATE]: DefaultState<`${typeof API.EXTERNAL_LETTERS_REQUIRE_UPDATE}`, 'post'>
  [EXTERNAL_LETTER_COMPLETE]: DefaultState<`${typeof API.EXTERNAL_LETTERS_COMPLETE}`, 'post'>
} = () => ({
  // [LETTER_INCOMING_LIST]: defaultState(),
  // [LETTER_OUTGOING_LIST]: defaultState(),
  [EXTERNAL_LETTERS_LIST]: defaultState(),
  [EXTERNAL_LETTER_ITEM]: defaultState(),
  [EXTERNAL_LETTER_DELETE]: defaultState(),
  [EXTERNAL_LETTER_COMMENT_TEMPLATES]: defaultState(),
  [EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE]: defaultState(),
  [EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE]: defaultState(),
  [EXTERNAL_LETTER_SEND_TO_INFORM]: defaultState(),
  [EXTERNAL_LETTER_PROVIDE_RESOLUTION]: defaultState(),
  [EXTERNAL_LETTER_CONFIRM_INFORMED]: defaultState(),
  [EXTERNAL_LETTER_COMPLETE_EXECUTION]: defaultState(),
  [EXTERNAL_LETTER_REQUIRE_UPDATE]: defaultState(),
  [EXTERNAL_LETTER_COMPLETE]: defaultState(),
})
